











































































































import Vue from 'vue'
import Editor from 'vue2-ace-editor'
import { fetchScriptById, fetchScriptList, createScript, publishScript } from '../services/script-client'
import { ScriptCreateData, ScriptCreateResponseData, ScriptListData, ScriptShowData } from '../types'
import { regexVersion } from '@morpheus/utils/admin-vue/helpers/regex'

export default Vue.extend({
  name: 'ScriptEdit',
  components: {
    Editor
  },
  data () {
    return {
      regex: {
        version: regexVersion
      },
      isLoading: false,
      itemsList: [] as Array<ScriptShowData>,
      selectedScriptId: '',
      selectedScript: {} as ScriptShowData,
      isScriptEdited: false,
      newVersion: ''
    }
  },
  watch: {
    selectedScriptId (val) {
      if (val) {
        this.fetchScript(val)
      }
    }
  },
  mounted () {
    this.updateScriptsList()
  },
  methods: {
    async updateScriptsList (activeScriptId?: string) {
      this.$store.commit('global/setLoading', true)
      await this.fetchItems()

      if (!this.itemsList.length) {
        this.$store.commit('global/setLoading', false)

        return false
      }

      if (activeScriptId) {
        this.selectedScriptId = activeScriptId
      } else {
        const liveScript:any = this.itemsList.find((script: ScriptShowData) => {
          return script.live
        })

        if (liveScript && liveScript._id) {
          this.selectedScriptId = liveScript._id
        } else {
          this.selectedScriptId = this.itemsList[0]._id
        }
      }

      this.$store.commit('global/setLoading', false)
    },
    fetchItems () {
      this.isLoading = true
      return fetchScriptList()
        .then(({ items, total }: ScriptListData) => {
          this.itemsList.splice(0, this.itemsList.length)
          items.forEach((item: ScriptShowData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchScript (id: string) {
      this.isLoading = true
      fetchScriptById(id)
        .then((script: ScriptShowData) => {
          this.selectedScript = script
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editorInit (editor: any) {
      require('brace/mode/javascript') // fixme! ES6 syntax is missing. Waiting for vue2-ace-editor update
      require('brace/theme/twilight')
    },
    changeScript (value: string) {
      this.isScriptEdited = true
    },
    save () {
      this.isLoading = true
      const script: ScriptCreateData = {
        source: this.selectedScript.source
      }

      if (this.newVersion) {
        script.version = this.newVersion
      }
      createScript(script)
        .then((response: ScriptCreateResponseData) => {
          this.updateScriptsList(response._id)
          this.isScriptEdited = false
          this.$store.commit('global/addNotification', {
            text: `You successfully saved new script version!`,
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    publish () {
      this.isLoading = true
      const version = `${this.selectedScript.version.major}.${this.selectedScript.version.minor}.${this.selectedScript.version.patch}.${this.selectedScript.version.build}`
      publishScript(version)
        .then((response) => {
          // Getting updated ItemList after publishing
          this.fetchItems()
          // Updating selectedScript for action block configuration
          this.fetchScript(this.selectedScriptId)
          this.$store.commit('global/addNotification', {
            text: `You successfully published script version ${version}!`,
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
})
